import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { AccordionItem } from './components/accordionItem/accordionItem.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const StyledAccordionItem: StyledComponent<typeof AccordionItem> = styled(AccordionItem)`
  & + & {
    border-top: 1px solid ${Color.Gray300};
  }
`;
